import React from 'react';
import { Check, Star, ShieldCheck } from 'lucide-react';
import { GlassCard } from './GlassCard';

/**
 * PricingCard Component - DARK EDITION
 * Features a tiered layout for 12h and 24h duty cycles.
 * Optimized for black background with glowing glass effects.
 */
const PricingCard = ({
  lang = 'en',
  title,
  price,
  duration,
  features,
  isPopular = false,
  delay = 0,
}) => {
  const isAr = lang === 'ar';

  return (
    <GlassCard
      delay={delay}
      className={`relative p-8 h-full flex flex-col transition-all duration-500 ${
        isPopular
          ? 'border-2 border-medical-blue-500 shadow-[0_0_40px_rgba(14,165,233,0.15)] scale-105 z-10 bg-white/[0.05]'
          : 'border-white/10 hover:border-medical-blue-500/50 bg-white/[0.02]'
      }`}
    >
      {/* Popular Badge */}
      {isPopular && (
        <div className='absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-1.5 bg-medical-blue-600 text-white rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg shadow-medical-blue-600/30'>
          {isAr ? 'أفضل قيمة' : 'Best Value'}
        </div>
      )}

      {/* Header */}
      <div className={`mb-8 ${isAr ? 'text-right' : 'text-left'}`}>
        <div
          className={`inline-flex p-3 rounded-2xl mb-4 ${
            isPopular
              ? 'bg-medical-blue-600 text-white'
              : 'bg-white/5 text-medical-blue-400 border border-white/10'
          }`}
        >
          {isPopular ? <Star size={24} /> : <ShieldCheck size={24} />}
        </div>
        <h3 className='text-xl font-black text-white mb-1'>{title}</h3>
        <p className='text-xs font-bold text-gray-500 uppercase tracking-wider'>
          {duration}
        </p>
      </div>

      {/* Price Section */}
      <div
        className={`mb-8 flex items-baseline gap-2 ${isAr ? 'flex-row-reverse' : ''}`}
      >
        <span className='text-5xl font-black text-white'>{price}</span>
        <span className='text-xl font-bold text-medical-blue-400'>
          {isAr ? 'د.ك' : 'KD'}
        </span>
      </div>

      {/* Features List */}
      <div className='space-y-4 mb-10 flex-grow'>
        {features.map((feature, index) => (
          <div
            key={index}
            className={`flex items-start gap-3 ${isAr ? 'flex-row-reverse text-right' : 'text-left'}`}
          >
            <div
              className={`mt-1 p-0.5 rounded-full ${
                isPopular
                  ? 'bg-green-500/20 text-green-400'
                  : 'bg-white/5 text-medical-blue-400'
              }`}
            >
              <Check size={12} strokeWidth={4} />
            </div>
            <span className='text-sm font-medium text-gray-400 leading-tight'>
              {feature}
            </span>
          </div>
        ))}
      </div>

      {/* Action Button */}
      <button
        onClick={() =>
          window.open(
            `https://wa.me/96550097296?text=${encodeURIComponent(
              isAr ? `أود الاستفسار عن ${title}` : `I'm interested in ${title}`,
            )}`,
            '_blank',
          )
        }
        className={`w-full py-4 rounded-2xl font-black text-sm uppercase tracking-widest transition-all active:scale-[0.98] ${
          isPopular
            ? 'bg-medical-blue-600 text-white shadow-xl shadow-medical-blue-600/20 hover:bg-medical-blue-500'
            : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'
        }`}
      >
        {isAr ? 'احجز الآن' : 'Book Now'}
      </button>
    </GlassCard>
  );
};

export default PricingCard;
